import { createContext, useContext, useEffect } from 'react';
import { useLeaflet } from 'react-leaflet';

export const MapControlsContext = createContext(null);
export const useMapControls = () => useContext(MapControlsContext);

// This is the only shared-controls component mounted under the native map.
// The host and all interactive panels live outside Leaflet's event boundary.
export function MapControlsBridge() {
  const leaflet = useLeaflet();
  const controls = useMapControls();
  const setLeaflet = controls && controls.setLeaflet;
  useEffect(() => {
    if (!setLeaflet) return undefined;
    setLeaflet(leaflet);
    return () => setLeaflet({});
  }, [leaflet, setLeaflet]);
  return null;
}
